import * as React from "react";
function SvgSmileyTag(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M30.5 17.37l-7.08-7.08-9.97 9.96v7.09h7.09l9.96-9.97z"
      />
      <path
        d="M22.24 11.46a11 11 0 10-9.78 15.87c.34 0 .67 0 1-.05"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle cx={8.47} cy={14.39} r={1.99} />
      <circle cx={16.44} cy={14.39} r={1.99} />
      <circle cx={18.43} cy={22.35} r={1.99} />
      <path
        d="M6.75 19.37a7 7 0 005.71 3"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSmileyTag);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
